import { render, staticRenderFns } from "./editInfoDialog.vue?vue&type=template&id=530ddea8"
import script from "./editInfoDialog.vue?vue&type=script&lang=js"
export * from "./editInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports